import { render, staticRenderFns } from "./ColorContrastWarning.vue?vue&type=template&id=33e7605e&scoped=true&"
import script from "./ColorContrastWarning.vue?vue&type=script&lang=js&"
export * from "./ColorContrastWarning.vue?vue&type=script&lang=js&"
import style0 from "./ColorContrastWarning.vue?vue&type=style&index=0&id=33e7605e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../backend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e7605e",
  null
  
)

export default component.exports